// Cada superfície possui sua própria geração. Abortar economiza rede; a
// identidade também protege respostas já resolvidas ou transportes sem abort.
export const criarControleLeituraEscala = () => {
	let geracao = 0;
	let controller = null;
	const cancelar = () => {
		geracao += 1;
		controller?.abort();
		controller = null;
	};
	return {
		cancelar,
		iniciar() {
			cancelar();
			const atual = geracao;
			const leitura = new AbortController();
			controller = leitura;
			return {
				signal: leitura.signal,
				ehAtual: () => atual === geracao && !leitura.signal.aborted,
			};
		},
	};
};
